import { Box } from '@mui/material';
import { DataCellProps } from '../types';

export const TeamIdCell = ({ team }: DataCellProps) => {
  return <Box textAlign={'left'}>{team.id}</Box>;
};
